import {Injectable} from '@angular/core';
import {BehaviorSubject,  Observable } from 'rxjs';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import { TypeAgent } from '../type-agents/type-agents.model';

@Injectable()
export class TypeAgentsService {
  private readonly urlBase = '/api/';

  constructor (private httpClient: HttpClient) {}

  getTypeAgents(): Observable<TypeAgent[]> {
    return this.httpClient.get<TypeAgent[]>(this.urlBase + 'getTypeAgents');
  }

  saveTypeAgent(typeAgent: TypeAgent) {
    return this.httpClient.post(this.urlBase + 'saveTypeAgent', typeAgent);
  }

  deleteTypeAgent(id: number) {
    return this.httpClient.post(this.urlBase + 'deleteTypeAgent', {id: id});
  }

  lookforChildren(id: number): Observable<object> {
    return this.httpClient.get(this.urlBase + 'lookforChildren?id=' + id);
  }

}
